var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9867 29.1121C27.8873 30.2588 27.5076 31.386 26.8478 32.384L14.1565 51.5804C14.0501 51.0832 13.9934 50.557 13.9934 50.004L13.9934 6.99603C13.9934 6.44296 14.0501 5.91675 14.1565 5.4196L26.8478 24.616C27.5076 25.614 27.8873 26.7412 27.9868 27.8879L27.9867 29.1121ZM28.1498 51.5804L26.6242 53.888C23.1355 59.1648 15.3773 57.2879 14.1565 51.5804L12.6308 53.888C8.83828 59.6244 0 56.9066 0 50.004L1.83274e-06 6.99603C2.10416e-06 0.0933781 8.83829 -2.62443 12.6308 3.112L14.1565 5.4196C15.3773 -0.287876 23.1355 -2.1648 26.6242 3.112L28.1498 5.41961C28.0435 5.91675 27.9868 6.44296 27.9868 6.99603V27.8879C28.0221 28.2952 28.0221 28.7048 27.9867 29.1121V50.004C27.9867 50.557 28.0435 51.0832 28.1498 51.5804ZM28.1498 51.5804L40.8412 32.384C42.3951 30.0336 42.3951 26.9664 40.8412 24.616L28.1498 5.41961C29.3707 -0.287874 37.1289 -2.1648 40.6176 3.112L54.8345 24.616C56.3885 26.9664 56.3885 30.0336 54.8345 32.384L40.6176 53.888C37.1289 59.1648 29.3707 57.2879 28.1498 51.5804Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcIcon);
export default __webpack_public_path__ + "static/media/edc-icon.7433d1b3612cfcee15757f01986dae27.svg";
export { ForwardRef as ReactComponent };